<template>
  <section class="information-accordion-module-component">
    <div class="inner-container">
      <h2
        class="text-[40px] text-balanced text-center"
        v-html="data.section_title"></h2>

      <div class="accordion-container">
        <div
          v-for="(item, index) in data.collapsible_items"
          :key="index"
          class="accordion-item">
          <div class="accordion-header">
            <h3
              class="header-5 text-balanced normal-case"
              @click="toggle(index)"
              v-html="item.title"></h3>
            <button
              class="accordion-title-toggle"
              :class="{ active: open[index] }"
              @click="toggle(index)">
              <img src="@/assets/img/caret-down-progressive.svg" />
            </button>
          </div>
          <Vue3SlideUpDown
            v-model="open[index]"
            :class="open[index] ? 'open' : 'closed'"
            class="accordion-content">
            <div class="divider"></div>
            <div
              class="content"
              v-html="item.content"></div>
          </Vue3SlideUpDown>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "InformationAccordionComponent",
    "CLASSNAME": "information-accordion-module-component",
    "URL": "http://vuevitewp.local/test"
   }
  #ENDMETA */

/*
 *   Insert your logic here
 */

import { ref, onMounted } from 'vue'
import Vue3SlideUpDown from 'vue3-slide-up-down'

const props = defineProps(['data'])

const accordionItems = ref(props.data.collapsible_items)
const open = ref([])

const toggle = (idx) => {
  open.value[idx] = !open.value[idx]
}

onMounted(() => {
  accordionItems.value.forEach(() => {
    open.value.push(false)
  })
})
</script>

<style lang="scss" scoped>
.information-accordion-module-component {
  @apply w-full max-w-screen-xl mx-auto bg-functional;

  .inner-container {
    @apply flex flex-col gap-8 lg:gap-14;

    .accordion-container {
      @apply flex flex-col bg-white rounded-[10px] px-8;

      .accordion-item {
        @apply flex flex-col z-2;

        .accordion-header {
          @apply flex items-center gap-2 justify-between py-3;

          h3 {
            @apply cursor-pointer;
          }
        }

        .accordion-title-toggle {
          @apply flex-[1_0_auto] bg-functional flex justify-center items-center rounded-full max-w-[36px] w-9 h-9 transition-transform duration-300 ease-in-out cursor-pointer;

          &.active {
            transform: rotate(180deg);
          }
        }

        .accordion-content {
          @apply overflow-hidden;

          .divider {
            @apply w-[66px] h-[3px] bg-progressive mb-6 mt-2 relative;

            &:after {
              @apply content-[''] absolute top-0 w-1/2 right-0 bg-balanced h-full;
            }
          }

          .content {
            @apply pb-10;

            &:deep() {
              .pre-ul {
                @apply pl-2 lg:pl-10;
              }

              strong {
                @apply font-bold;
              }

              p {
                @apply mb-5;
              }

              a {
                @apply underline;
              }

              ol {
                @apply list-decimal pl-9 mb-5 lg:pl-[80px];
              }

              ul {
                @apply list-disc pl-9 mb-5 lg:pl-[80px];
              }

              li {
                &::marker {
                  @apply text-progressive;
                }

                @apply text-[18px] mb-2;

                strong {
                  @apply font-bold;
                }
              }
            }
          }
        }

        + .accordion-item {
          @apply border-t border-t-gray_green border-opacity-20;
        }
      }
    }
  }
}
</style>
